import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetch as fetchMessages } from 'actions/messages';
import {
  goBackFromSocialAct,
  sendSocialInvite,
} from 'actions/storylet';

import * as ActPropTypes from 'types/act';

import getContactName from './getContactName';

import InvitationFormComponent from './InvitationFormComponent';

class InvitationFormContainer extends Component {
  static propTypes = {
    actMessagePreview: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    eligibleFriends: PropTypes.arrayOf(ActPropTypes.eligibleFriend).isRequired,
    isSending: PropTypes.bool.isRequired,
    selectedContactId: PropTypes.number,
  }

  static defaultProps = {
    selectedContactId: undefined,
  }

  mounted = false

  state = {
    isWorking: false,
    value: '',
  }

  componentDidMount = () => {
    this.mounted = true;
  }

  componentWillUnmount = () => {
    this.mounted = false;
  }

  handleChange = (e) => {
    this.setState({ value: e.target.value });
  }

  handleGoBack = () => {
    const { dispatch } = this.props;
    dispatch(goBackFromSocialAct());
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const {
      branch,
      dispatch,
      selectedContactId,
    } = this.props;
    const { isWorking, value } = this.state;

    // Don't submit a second time if we're working
    if (isWorking) {
      return;
    }

    this.setState({ isWorking: true });

    // TODO: 'messageInput'? Seriously? Let's refactor the action -> service code.
    const data = {
      branchId: branch.id,
      targetCharacterId: selectedContactId,
      messageInput: value,
    };

    await dispatch(sendSocialInvite(data));
    if (this.mounted) {
      this.setState({ isWorking: false });
    }
    dispatch(fetchMessages());
  }

  render = () => {
    const {
      actMessagePreview,
      eligibleFriends,
      isSending,
      selectedContactId,
    } = this.props;

    const {
      isWorking,
      value,
    } = this.state;

    const contactName = getContactName({ eligibleFriends, selectedContactId });

    return (
      <InvitationFormComponent
        preview={actMessagePreview}
        contactName={contactName}
        disabled={!selectedContactId}
        isSending={isSending}
        isWorking={isWorking}
        onChange={this.handleChange}
        onGoBack={this.handleGoBack}
        onSubmit={this.handleSubmit}
        value={value}
      />
    );
  }
}

const mapStateToProps = ({
  socialAct: {
    actMessagePreview,
    branch,
    isSending,
  },
}) => ({
  actMessagePreview,
  branch,
  isSending,
});

export default connect(mapStateToProps)(InvitationFormContainer);